module.exports = __webpack_public_path__ + "static/media/delete_white_24dp.5430bdf7.svg";